import React from 'react';

import { Button, Stack, Text } from '@nerdwallet/currency';
import {
  ElementImpression,
  ElementInteraction,
} from '@nerdwallet/nw-client-lib/tracking';

export interface MarketplaceCtaProps {
  title: string;
  subtitle: string;
  buttonText: string;
  url: string;
  elementName: string;
  impressionId: string;
  impressionKey: string;
  className?: string;
}

const MarketplaceCta: React.FC<MarketplaceCtaProps> = ({
  title,
  subtitle,
  buttonText,
  url,
  elementName,
  impressionId,
  className,
  impressionKey,
}) => {
  return (
    <div className={className}>
      <Stack spacing="3">
        <Text size="small" bold>
          {title}
        </Text>
        <Text size="small">{subtitle}</Text>
        <ElementImpression id={impressionKey} elementName={elementName}>
          <ElementInteraction
            impressionId={impressionId}
            elementName={elementName}
            type="CLICK"
          >
            <Button href={url} block target="_blank">
              {buttonText}
            </Button>
          </ElementInteraction>
        </ElementImpression>
      </Stack>
    </div>
  );
};

export default MarketplaceCta;
